import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes: any = {
	
};

@createModule('CampaignCollectorPageHeader')
/**
 * Header module implementation.
 *
 * @author 
 */
export class CampaignCollectorPageHeader extends TerrificSpec {
	ticking: boolean = false;
	$ctx: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		resolve();
	}

	stop() {}
}
